(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7168],{

/***/ 8862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _all_routes_; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(5153);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/index.ts + 639 modules
var ui_container = __webpack_require__(4485);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./style/allRoutes.style.ts

var RootContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "allRoutesstyle__RootContainer",
  componentId: "sc-8j227n-0"
})(["&.home{overflow-y:scroll;height:100vh;}"]);
var LandingInitial = styled_components_browser_esm["default"].div.withConfig({
  displayName: "allRoutesstyle__LandingInitial",
  componentId: "sc-8j227n-1"
})(["width:100vw;height:100vh;background:#000;display:flex;align-items:center;justify-content:center;color:#fff;position:fixed;top:0;left:0;z-index:41;& .myProgress{height:5px;background:#000;width:100%;position:fixed;top:0;}& .myBar{height:5px;background:#d88585;border-radius:0 8px 8px 0px;animation:progress 4s cubic-bezier(0,0.76,0.99,0.26);}@keyframes progress{from{width:0;}to{width:100%;}}"]);
var LandingLoading = styled_components_browser_esm["default"].div.withConfig({
  displayName: "allRoutesstyle__LandingLoading",
  componentId: "sc-8j227n-2"
})(["width:326px;animation:fadeIn 4s;@keyframes fadeIn{from{opacity:0;}to{opacity:100%;}}"]);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 9 modules
var src = __webpack_require__(5537);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./pages/[[...all_routes]].tsx











// Magic import, https://github.com/nrwl/nx/issues/9017#issuecomment-1140066503
path_browserify_default().resolve("./next.config.js");

var Index = function Index(_ref) {
  var _cmsData$, _cmsData$2, _cmsData$3, _cmsData$3$seo, _cmsData$3$seo$, _cmsData$4, _cmsData$4$seo, _cmsData$4$seo$, _cmsData$5, _cmsData$5$config;

  var cmsData = _ref.cmsData;

  var _ref2 = (cmsData === null || cmsData === void 0 ? void 0 : cmsData.meta) || {},
      pageViewEvent = _ref2.pageViewEvent;

  var components = cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$ = cmsData[0]) === null || _cmsData$ === void 0 ? void 0 : _cmsData$.jsons;

  var _ref3 = (cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$2 = cmsData[0]) === null || _cmsData$2 === void 0 ? void 0 : _cmsData$2.config) || {},
      className = _ref3.className;

  var title = (cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$3 = cmsData[0]) === null || _cmsData$3 === void 0 ? void 0 : (_cmsData$3$seo = _cmsData$3.seo) === null || _cmsData$3$seo === void 0 ? void 0 : (_cmsData$3$seo$ = _cmsData$3$seo[0]) === null || _cmsData$3$seo$ === void 0 ? void 0 : _cmsData$3$seo$.title) || "TripMoney - Buy Forex Card & Travel Insurance Online | Forex India";
  (0,react.useEffect)(function () {
    if (pageViewEvent) {
      (0,analytics/* pushEvent */.AB)(pageViewEvent);
    }
  }, [pageViewEvent]);
  (0,react.useEffect)(function () {
    if (className) document.querySelector("body").classList.add(className.split(" "));
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
      value: {
        fetcher: src/* fetcher */._i,
        revalidateOnFocus: false
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_container/* LandingPageDocument */.ax, {
        metaTags: (cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$4 = cmsData[0]) === null || _cmsData$4 === void 0 ? void 0 : (_cmsData$4$seo = _cmsData$4.seo) === null || _cmsData$4$seo === void 0 ? void 0 : (_cmsData$4$seo$ = _cmsData$4$seo[0]) === null || _cmsData$4$seo$ === void 0 ? void 0 : _cmsData$4$seo$.meta_tags) || [],
        preloadedImages: (cmsData === null || cmsData === void 0 ? void 0 : (_cmsData$5 = cmsData[0]) === null || _cmsData$5 === void 0 ? void 0 : (_cmsData$5$config = _cmsData$5.config) === null || _cmsData$5$config === void 0 ? void 0 : _cmsData$5$config.preloadedImages) || [],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RootContainer, {
          id: "root_container",
          className: className,
          children: components === null || components === void 0 ? void 0 : components.map(function (component, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ui_container/* RenderSection */.j3, {
              component: component,
              pageViewEvent: pageViewEvent,
              className: className
            }, index);
          })
        })
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _all_routes_ = (Index);

/***/ }),

/***/ 5297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...all_routes]]",
      function () {
        return __webpack_require__(8862);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(5297); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);